import { api, unwrap } from './client';

// Config
export async function getPayrollConfigs() {
  const res = await api.get('/finance/payroll/config');
  return unwrap(res) || [];
}

export async function getPayrollConfig(userId) {
  const res = await api.get(`/finance/payroll/config/${userId}`);
  return unwrap(res);
}

export async function createPayrollConfig(payload) {
  const res = await api.post('/finance/payroll/config', payload);
  return unwrap(res);
}

export async function updatePayrollConfig(userId, payload) {
  const res = await api.put(`/finance/payroll/config/${userId}`, payload);
  return unwrap(res);
}

export async function uploadPayrollConfigsExcel(file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post('/finance/payroll/upload-excel', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return unwrap(res);
}

// Monthly Run / Generation
export async function generatePayroll(payload) {
  const res = await api.post('/finance/payroll/generate', payload);
  return unwrap(res);
}

export async function generatePayrollBulk(payload) {
  const res = await api.post('/finance/payroll/generate/bulk', payload);
  return unwrap(res);
}

export async function generatePayrollAll(payload) {
  const res = await api.post('/finance/payroll/generate/all', payload);
  return unwrap(res);
}

// Edit Draft
export async function updateDraftPayroll(id, payload) {
  const res = await api.put(`/finance/payroll/${id}`, payload);
  return unwrap(res);
}

// Locking and Paying
export async function lockPayroll(id) {
  const res = await api.put(`/finance/payroll/${id}/lock`, {});
  return unwrap(res);
}

export async function lockPayrollBulk(payload) {
  const res = await api.put('/finance/payroll/lock/bulk', payload);
  return unwrap(res);
}

export async function markPayrollPaid(id) {
  const res = await api.put(`/finance/payroll/${id}/paid`, {});
  return unwrap(res);
}

export async function markPayrollPaidBulk(payload) {
  const res = await api.put('/finance/payroll/paid/bulk', payload);
  return unwrap(res);
}

// Retrieval
export async function listPayrollForPeriod({ month, year }) {
  const res = await api.get('/finance/payroll', { params: { month, year } });
  return unwrap(res) || [];
}

export async function listMyPayroll() {
  const res = await api.get('/finance/payroll/my');
  return unwrap(res) || [];
}

export async function getPayroll(id) {
  const res = await api.get(`/finance/payroll/${id}`);
  return unwrap(res);
}

export async function getPayrollSlip(id) {
  const res = await api.get(`/finance/payroll/${id}/slip`);
  return unwrap(res);
}

/**
 * Download the salary slip PDF generated by the backend.
 * Hits GET /finance/payroll/{id}/slip/pdf and triggers a browser save-as dialog.
 */
export async function downloadPayrollSlipPdf(id, filename) {
  const res = await api.get(`/finance/payroll/${id}/slip/pdf`, {
    responseType: 'blob',
  });
  const blob = new Blob([res.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename || `salary_slip_${id}.pdf`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

// Legacy Salary endpoints if still used
export async function createSalaryStructure(payload) {
  const res = await api.post('/finance/salary', payload);
  return unwrap(res);
}

export async function getActiveSalary(userId) {
  const res = await api.get(`/finance/salary/${userId}/active`);
  return unwrap(res);
}

export async function getSalaryHistory(userId) {
  const res = await api.get(`/finance/salary/${userId}/history`);
  return unwrap(res) || [];
}
